import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { omitBy, isNil } from "lodash";

import { DOMAIN_AI } from "../domain";

import { QUESTION_ASSISTANT } from "@constants";

export const ACTION_GET_AI_ASSISTANCE = "GET_AI_ASSISTANCE";

interface AIAssistanceRequest {
  question: string;
  description: string;
  companyName?: string;
  language: string;
  aiPrompt: string;
  userInput: string;
}

const getAIAssistance = async (body: AIAssistanceRequest): Promise<string> => {
  const response = await fetch(QUESTION_ASSISTANT, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(omitBy(body, isNil)),
  });

  if (!response.ok) {
    throw new Error(`AI assistance request failed: ${response.statusText}`);
  }

  return response.text();
};

export const useGetAIAssistance = (): UseMutationResult<
  string,
  Error,
  AIAssistanceRequest
> => {
  return useMutation<string, Error, AIAssistanceRequest>({
    mutationKey: [DOMAIN_AI, ACTION_GET_AI_ASSISTANCE],
    mutationFn: getAIAssistance,
  });
};
